export interface Paragraph {
  heading: string;
  text: string[];
}

export interface TopicAndContents {
  [key: string]: string[];
}

export enum ManifoldTabs {
  RESEARCH = 0,
  NOTEBOOK = 1,
  CITATAION = 2,
  ANALYTICS = 3,
  PARAPHRASER = 4,
  SUMMARIZER = 5,
}

export enum QuillEditorActionTypes {
  RESET = '',
  PPHR = 'paraphrase',
  SMZR = 'summarize',
  CITATION = 'CITATION',
  SEARCH = 'SEARCH',
}

export enum SelectionEndMenuTypes {
  NONE = 'none',
  RIBBON = 'ribbon',
  MENU = 'menu',
}
